/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_TitleInputs */

const en_diff_title = /** @type {(inputs: Diff_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Diff`)
};

const ko_diff_title = /** @type {(inputs: Diff_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 비교`)
};

const ja_diff_title = /** @type {(inputs: Diff_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON比較`)
};

/**
* | output |
* | --- |
* | "JSON Diff" |
*
* @param {Diff_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_title = /** @type {((inputs?: Diff_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_title(inputs)
	if (locale === "ko") return ko_diff_title(inputs)
	return ja_diff_title(inputs)
});